import React from 'react'

const HamburgerIcon = () => {
    return (
        <svg
            width="20"
            height="16"
            viewBox="0 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="hamburger-icon"
        >
            <g id="menu icon">
                <path id="Rectangle 122" d="M20 0H0V3.2H20V0Z" fill="white" />
                <path id="Rectangle 123" d="M20 6.3999H0V9.5999H20V6.3999Z" fill="white" />
                <path id="Rectangle 124" d="M20 12.8H0V16H20V12.8Z" fill="white" />
            </g>
        </svg>
    )
}

export default HamburgerIcon
